import './two-column-with-image.css';

export default (element, data) => {};